<template>
  <Modal v-model="modal" :title="safe.Email?$t('title.w26'):$t('title.w27')" :mask-closable="false">
    <div>
      <!-- 修改 -->
      <Form label-position="top" v-if="mode=='edit'" :model="form1" ref="edit" :rules="form1Rules">
        <FormItem :label="`${$t('label.w42')} (${safe.Email})`" prop="oldEmailCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p2')" v-model="form1.oldEmailCode" />
            </Col>
            <Col span="6">
              <Codebtn type="SendUpdateOldEmailCode" />
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="$t('label.w43')" prop="email1">
          <Input :placeholder="$t('pl.p9')" v-model="form1.email1" />
        </FormItem>
        <FormItem :label="$t('label.w44')" prop="newEmailCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p2')" v-model="form1.newEmailCode" />
            </Col>
            <Col span="6">
              <Codebtn
                type="SendUpdateNewEmailCode"
                :to="form1.email1"
                :disabled="form1.email1==''"
              />
            </Col>
          </Row>
        </FormItem>
      </Form>

      <!-- 新绑定 -->
      <Form label-position="top" :model="form" ref="new" :rules="formRules" v-else>
        <FormItem :label="`${$t('label.w35')} (${safe.MobliePhone})`" prop="phoneCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p28')" v-model="form.phoneCode" />
            </Col>
            <Col span="6">
              <Codebtn type="SendBindEmailPhoneCode" />
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="$t('label.w45')" prop="email">
          <Input :placeholder="$t('pl.p9')" v-model="form.email" />
        </FormItem>
        <FormItem :label="$t('label.w36')" prop="emailCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p2')" v-model="form.emailCode" />
            </Col>
            <Col span="6">
              <Codebtn type="SendBindEmailCode" :to="form.email" :disabled="form.email==''" />
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <Button type="primary" :loading="btnLoading" @click="submit">{{$t('btn.b5')}}</Button>
    </template>
  </Modal>
</template>

<script>
import Codebtn from "@/components/sendCodeButton";
import formRule from "@/libs/formRule";
export default {
  components: { Codebtn },
  data() {
    return {
      modal: false,
      btnLoading: false,
      form: {
        phoneCode: "",
        email: "",
        emailCode: ""
      },
      formRules: {
        phoneCode: formRule.code,
        email: formRule.email,
        emailCode: formRule.code
      },
      form1: {
        oldEmailCode: "",
        // 使用email1 防止FormItem的prop属性冲突
        email1: "",
        newEmailCode: ""
      },
      form1Rules: {
        oldEmailCode: formRule.code,
        email1: formRule.email,
        newEmailCode: formRule.code
      }
    };
  },
  methods: {
    async submit() {
      this.btnLoading = true;
      let valid = await this.$refs[this.mode].validate();
      if (!valid) {
        this.btnLoading = false;
        return;
      } else {
        let res;
        if (this.mode == "edit") {
          res = await this.$axios.post(
            "/Member/RZJProfile/UserUpdateBindEmail",
            {
              oldEmailCode: this.form1.oldEmailCode,
              email: this.form1.email1,
              newEmailCode: this.form1.newEmailCode
            }
          );
        } else {
          res = await this.$axios.post(
            "/Member/RZJProfile/UserBindEmail",
            this.form
          );
        }
        if (res.err) {
          res.throw();
          this.btnLoading = false;
        } else {
          // 重新获取状态
          this.btnLoading = false;
          this.$store.dispatch("user/getSafe");
          this.$Message.success(
            this.mode == "edit" ? this.$t("msg.m38") : this.$t("msg.m36")
          );
          this.modal = false;
        }
      }
    }
  },
  computed: {
    safe() {
      return this.$store.state.user.safe;
    },
    mode() {
      return this.safe.Email ? "edit" : "new";
    }
  },
  watch: {
    modal(v) {
      this.$refs[this.mode].resetFields();
    }
  }
};
</script>

